module.exports = __webpack_public_path__ + "static/caterpillar-60f1c93c9f9a20265eaf451516f63488.svg";